import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext } from 'react';
import UserGoBack from "../../user/UserGoBack";
import ArticleUtile from "../ArticleUtile";
import RightPartContent from "../RightPartContent";
import { useTopic } from "../../../hooks/useTopic";

const  HelpEssentielsCompte = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { topic, isLoading, LoadingComponent } = useTopic();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Votre compte', link: '/topics/compte'},
    { label: 'Gérer votre compte', link: '/topics/compte/gestion-compte'},
    { label: topic.title, link: topic.link},
  ]

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex">
          <div className="help-left-part">
            <p className="fw-500 fz-15">
              En vous connectant à votre<a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings`}>compte</a>
              Wodzone, vous bénéficiez d'un moyen simple d'accéder à vos préférences et paramètres personnels, que ce soit pour modifier votre adresse e-mail ou autres informations.<br/>Il est vivement recommandé de compléter votre profil afin de faciliter vos inscriptions aux compétitions.
            </p>
            <ul>
              <li className="fw-500 fz-15 mt-24">
                <p className="help-text">
                  <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/personal-info`}>Informations personnelles</a>
                  : permet de consulter ou modifier vos données personnelles, telles que votre <strong className="fw-600">nom</strong>, 
                  votre <strong className="fw-600">prénom</strong>, votre <strong className="fw-600">photo de profil</strong>, votre <strong className="fw-600">adresse e-mail</strong>, votre <strong className="fw-600">numéro de téléphone</strong> etc.
                </p>
              </li>
              <li className="fw-500 fz-15 mt-24">
                <p className="help-text">
                  <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/sportwear-size`}>Mes tailles sportwear</a>: permet de consulter ou modifier vos tailles de vêtement de sport. Une fois renseigné, si vous participez à un event qui propose des vêtements en goodies, vos informations seront déjà pré-rempli lors de votre inscription.
                  Et ce, même si c'est un coéquipier qui vous invite dans sa team.
                </p>
              </li>
              <li className="fw-500 fz-15 mt-24">
                <p className="help-text">
                  <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/personalization`}>Personnalisation</a>: Personnaliser vos couleurs de fond à votre goût. Il s'agit de la couleur qui souligne votre rang dans le classement ou votre place dans le planning lors d'une compétition.
                </p>
              </li>
              <li className="fw-500 fz-15 mt-24">
                <p className="help-text">
                  <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/events`}>Mes inscriptions</a>: C'est ici que vous retrouver toutes les compétitions dans lesquelles vous vous êtes inscrit.
                </p>
              </li>
              <li className="fw-500 fz-15 mt-24">
                <p className="help-text">
                  <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/loggin-settings`}>Connexion et sécurité</a>: permet de mettre à jour votre mot de passe et de sécuriser votre compte.
                </p>
              </li>
              <li className="fw-500 fz-15 mt-24">
                <p className="help-text">
                  <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/loggin-settings`}>Paiements et versements</a>: permet de consulter vos paiements, versements.
                </p>
              </li>
              <li className="fw-500 fz-15 mt-24">
                <p className="help-text">
                  <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/notifications`}>Notifications</a>: permet de choisir vos préférences de notification et de communication.
                </p>
              </li>
            </ul>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpEssentielsCompte